import { createAction } from '@reduxjs/toolkit';

export class CancelCheckMessages {
  static get action() {
    return createAction('chat/CANCEL_CHECK_MESSAGES');
  }
}
